import React from 'react';
import { motion } from 'framer-motion';
import { Phone, MessageSquare, Zap, Clock, ShieldCheck, BadgeCheck } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-24 bg-[#1A1A1A] text-white relative overflow-hidden" data-id="element-104">
      {/* Background accent */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-[#C8102E] opacity-10 blur-[100px] rounded-full transform translate-x-1/2" data-id="element-105"></div>
      <div className="absolute bottom-0 left-0 w-1/3 h-1/2 bg-[#C8102E] opacity-5 blur-[120px] rounded-full" data-id="element-106"></div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-107">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-108">
          {/* Free Estimate Badge - Hero of the section */}
          <motion.div initial={{
          scale: 0.9,
          opacity: 0
        }} whileInView={{
          scale: 1,
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="inline-flex items-center gap-2 px-5 py-2 rounded-full bg-[#C8102E] text-white font-bold mb-6 shadow-[0_0_25px_rgba(200,16,46,0.5)]" data-id="element-109">
            <BadgeCheck size={20} data-id="element-110" />
            <span className="uppercase tracking-wider text-sm" data-id="element-111">
              100% Free Estimates · No Obligation
            </span>
          </motion.div>

          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/5 text-gray-300 border border-white/10 font-semibold mb-6 text-sm uppercase tracking-wider" data-id="element-112">
            <Zap size={16} className="text-[#C8102E]" data-id="element-113" />
            Don't Wait Another Weekend
          </div>

          <h2 className="text-5xl md:text-7xl font-bold mb-8 leading-tight" data-id="element-114">
            GET YOUR <span className="text-[#C8102E]" data-id="element-115">FREE QUOTE</span>{' '}
            <br className="hidden md:block" data-id="element-116" />
            IN UNDER 60 SECONDS.
          </h2>

          <p className="text-xl md:text-2xl text-gray-300 mb-10 max-w-3xl mx-auto leading-relaxed" data-id="element-117">
            Tell us what you've got — a single piece, a full garage, or an
            entire property. We'll give you a{' '}
            <strong className="text-white" data-id="element-118">straight, honest price</strong> on
            the spot. No pressure. No hidden fees. No runaround.
          </p>

          {/* Trust Bar */}
          <div className="flex flex-wrap items-center justify-center gap-x-8 gap-y-3 mb-12 text-sm md:text-base font-semibold" data-id="element-119">
            <div className="flex items-center gap-2 text-gray-300" data-id="element-120">
              <BadgeCheck size={20} className="text-[#C8102E]" data-id="element-121" />
              <span data-id="element-122">Always Free</span>
            </div>
            <div className="flex items-center gap-2 text-gray-300" data-id="element-123">
              <Clock size={20} className="text-[#C8102E]" data-id="element-124" />
              <span data-id="element-125">Same-Day Response</span>
            </div>
            <div className="flex items-center gap-2 text-gray-300" data-id="element-126">
              <ShieldCheck size={20} className="text-[#C8102E]" data-id="element-127" />
              <span data-id="element-128">No Obligation</span>
            </div>
          </div>

          <div className="flex flex-col items-center gap-6 mb-12" data-id="element-129">
            <p className="text-sm uppercase tracking-[0.3em] text-gray-400 font-bold" data-id="element-130">
              Call or text for your free estimate
            </p>
            <a href="tel:8312407401" className="text-5xl md:text-7xl font-bold text-[#C8102E] hover:text-red-500 transition-colors drop-shadow-lg" data-id="element-131">
              (831) 240-7401
            </a>

            <div className="flex flex-col sm:flex-row gap-4 w-full justify-center mt-2" data-id="element-132">
              <a href="tel:8312407401" className="flex items-center justify-center gap-3 bg-[#C8102E] text-white px-10 py-5 rounded font-bold text-xl hover:bg-red-800 transition-all shadow-[0_0_20px_rgba(200,16,46,0.4)] hover:-translate-y-1" data-id="element-133">
                <Phone size={28} data-id="element-134" />
                <span data-id="element-135">Call for Free Estimate</span>
              </a>
              <a href="sms:8312407401" className="flex items-center justify-center gap-3 bg-white text-[#1A1A1A] px-10 py-5 rounded font-bold text-xl hover:bg-gray-100 transition-all shadow-lg hover:-translate-y-1" data-id="element-136">
                <MessageSquare size={28} data-id="element-137" />
                <span data-id="element-138">Text Us a Photo</span>
              </a>
            </div>
          </div>

          <div className="bg-white/5 border border-white/10 p-6 rounded-lg max-w-2xl mx-auto" data-id="element-139">
            <p className="text-gray-400 text-base md:text-lg" data-id="element-140">
              <strong className="text-white" data-id="element-141">Pro tip:</strong> Snap a photo of
              your junk and text it over — we can usually quote you in minutes
              without even stepping on-site.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}